enum CURRENCY {
  USD = 'USD',
  CAD = 'CAD',
  NZD = 'NZD',
}

export { CURRENCY };
